import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import * as _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NewFilterService {
    currentFilterWidgetConfig = new Subject<any>()

    private statusChangeData = new BehaviorSubject<any>(null);
    currentData = this.statusChangeData.asObservable();

    private key = 'SelectedStatus';
    private baseQuery = 'baseQueryPatientStatusChange';
    
    showBy = new Subject<any>();
    scatterPlotData = new Subject<any>();

    upsetChartFilteredData = new Subject<any>();
    chordChartFilteredData = new Subject<any>();

    locationName:any

    constructor(
        private apiService: ApiService
    ) {}

    updateScatterPlotData(value: any){
        this.scatterPlotData.next(value);
    }

    updateUpsetChart(value: any){
        this.upsetChartFilteredData.next(value);
    }
    updateChordChart(value: any){
        this.chordChartFilteredData.next(value);
    }
        
    sendData(data: any) {
        this.statusChangeData.next(data);
    }

    getPatientStatusData(): any {
        const data:any = sessionStorage.getItem(this.key);
        return JSON.parse(data)
    }

    setPatientStatusData(data:any) {
        const serializedData:any = JSON.stringify(data);
        sessionStorage.setItem(this.key, serializedData);
    }

    setPatientStatusBaseQuery(data:any) {
        const serializedData:any = JSON.stringify(data);
        sessionStorage.setItem(this.baseQuery, serializedData);
    }
    
    getPatientStatusBaseQuery() {
        const data:any = sessionStorage.getItem(this.baseQuery);
        return JSON.parse(data);
    }

    executeDynamicPatientQuery(endPoint:any, obj:any) {
        if(sessionStorage.getItem("brandKeyForFilters")) {
            let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
            let brand_key = JSON.parse(brandKey);
            obj['brand_key'] = brand_key;  
        }

        if(sessionStorage.getItem("tbl_name_suffix")) {
            let json:any = sessionStorage.getItem("tbl_name_suffix");
            json = JSON.parse(json);
            obj['tbl_name_suffix'] = json.tbl_name_suffix;  
        }
        return this.apiService.post(endPoint ? endPoint : 'kpi/get-execution-details', obj)
    }

    executePatientQuery(obj:any) {
        if(sessionStorage.getItem("brandKeyForFilters")) {
            let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
            let brand_key = JSON.parse(brandKey);
            obj['brand_key'] = brand_key;  
        }

        if(sessionStorage.getItem("tbl_name_suffix")) {
            let json:any = sessionStorage.getItem("tbl_name_suffix");
            json = JSON.parse(json);
            obj['tbl_name_suffix'] = json.tbl_name_suffix;  
        }
        return this.apiService.post('kpi/get-execution-details', obj)
    }
    executealertDataQuery(obj:any) {
        if(sessionStorage.getItem("brandKeyForFilters")) {
            let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
            let brand_key = JSON.parse(brandKey);
            obj['brand_key'] = brand_key;  
        }

        if(sessionStorage.getItem("tbl_name_suffix")) {
            let json:any = sessionStorage.getItem("tbl_name_suffix");
            json = JSON.parse(json);
            obj['tbl_name_suffix'] = json.tbl_name_suffix;  
        }
        return this.apiService.post('kpi/user-alerts', obj)
    }
    getTransactionData(endPoint:any, obj:any) {
        if(sessionStorage.getItem("brandKeyForFilters")) {
            let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
            let brand_key = JSON.parse(brandKey);
            obj['brand_key'] = brand_key;  
        }
        
        if(sessionStorage.getItem("tbl_name_suffix")) {
            let json:any = sessionStorage.getItem("tbl_name_suffix");
            json = JSON.parse(json);
            obj['tbl_name_suffix'] = json.tbl_name_suffix;  
        }
        return this.apiService.post(endPoint, obj)
    }

    // getSampleJsonData(fileName: any) {
    //     return this.apiService.getDoc(fileName)
    // }

    // setCurrentFilterWidgetConfig(config: any) {
    //     this.currentFilterWidgetConfig.next(config)
    // }
}